import React from 'react'
import { Element } from "@prismicio/react"

// New components approach for @prismicio/react
export const htmlSerializer = {
  heading2: ({ children, key }) => {
    return <h2 key={key || "h2"} className="h2">{children}</h2>
  }
}

export const htmlFooterSerializer = {
  heading3: ({ children, key }) => {
    return <h3 key={key || "h3"} className="h3">{children}</h3>
  }
}
